import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import AddThanphod from '@/components/AddThanphod'
import EditThanphod from '@/components/EditThanphod'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path : '/add-thanphod',
      name: 'AddThanphod',
      component: AddThanphod
    },
    {
      path: '/edit-thanphod/:thanphod_slug',
      name: 'EditThanphod',
      component: EditThanphod
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js